import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {InputFieldContainerBox} from "../../input-field/input-field.component";
import {SpecialPriceMarketUserOptions} from "../../../services/flight-search/flight-search-controller/flight-search-params.interface";
import {IFlightSearchControllerViewModel} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {HORIZONTAL_SPACING_PX} from "../../css-global-constants";

const SpecialPriceMarketBox = styled(InputFieldContainerBox)`
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    gap: ${HORIZONTAL_SPACING_PX};
    cursor: default;
`

const SpecialPriceMarketLabel = styled.div`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: ${props => props.theme.fontWeight.bold};
    padding-left: 16px;
`

const CheckBox = styled.input`
  cursor: pointer;  
`

const CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 12px;
  width: fit-content;
  cursor: pointer;
`

interface SpecialPriceMarketUserOptionComponentProps {

    optionsValue: SpecialPriceMarketUserOptions;
    searchController: IFlightSearchControllerViewModel;
}

const SpecialPriceMarketUserOptionComponent: React.FC<SpecialPriceMarketUserOptionComponentProps> = observer((props) => {
    const services = useServices();

    const onClickHandler = () => {
        if(props.optionsValue === props.searchController.fields.specialPriceMarketUserOption.value) {
            props.searchController.fields.specialPriceMarketUserOption.setValue(SpecialPriceMarketUserOptions.None);
        } else {
            props.searchController.fields.specialPriceMarketUserOption.setValue(props.optionsValue);
        }
    }

    const getLabel = () => {
        if(props.optionsValue === SpecialPriceMarketUserOptions.Regular) {
            return services.language.translationFor('Are you a resident in {market}?')
                .withParams({market: props.searchController.getSpecialPriceMarket()?.getMarketNameTranslation() ?? ""});
        } else {
            return services.language.translationFor('Are you a worker in {market}?')
                .withParams({market: props.searchController.getSpecialPriceMarket()?.getMarketNameTranslation() ?? ""});
        }
    }

    return (
        <CheckBoxContainer onClick={onClickHandler}>
            <CheckBox type={"checkbox"}
                      checked={props.optionsValue === props.searchController.fields.specialPriceMarketUserOption.value}
                      onChange={() => {}} />
            <SpecialPriceMarketLabel>
                {getLabel()}
            </SpecialPriceMarketLabel>
        </CheckBoxContainer>
    );
});

export const SpecialPriceMarketComponent: React.FC = observer(() => {
    const services = useServices();

    const searchController = services.flightSearch.searchController;

    const supportsSpecialPriceMarket = searchController.supportsSpecialPriceMarket();
    const supportsSeasonSpecialPriceMarket = searchController.supportsSeasonSpecialPriceMarket();

    if(!supportsSpecialPriceMarket && !supportsSeasonSpecialPriceMarket) {
        return null;
    }

    return (
        <SpecialPriceMarketBox isInFocus={false} hasError={false}>
            <SpecialPriceMarketUserOptionComponent optionsValue={SpecialPriceMarketUserOptions.Regular} searchController={searchController} />
            {supportsSeasonSpecialPriceMarket && <SpecialPriceMarketUserOptionComponent optionsValue={SpecialPriceMarketUserOptions.Season} searchController={searchController} />}
        </SpecialPriceMarketBox>
    )
});
